import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  width: "24",
  height: "24",
  viewBox: "0 0 23.8 23.8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m21.7 18-3.1 3.1-1.8-1.8",
  style: {"fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.8 13.1c0-.4.1-.9.1-1.2 0-6.1-4.9-11-11-11s-11 4.9-11 11 4.9 11 11 11c.4 0 .9 0 1.2-.1",
  style: {"fill":"none","stroke":"currentColor","stroke-width":"1.75","stroke-linecap":"round","stroke-linejoin":"round"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7 11.3c0 1.2.5 2.5 1.3 3.3.6.7 1.5 1.5 2.3 2 .7.5 1.7.4 2.5-.1.9-.5 1.5-1.1 2.2-1.8.9-.9 1.3-2.1 1.5-3.3 0-.7-.2-1.5-.7-2s-1.1-.9-1.8-.9c-.9-.1-1.7.4-2.3 1.1-.5-.7-1.2-1.1-2.1-1.1C8.2 8.5 7 9.7 7 11.3",
  style: {"fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }